/* ============================================================
 * CH TOOLS -- Hero · Brand Rotator  v4
 * assets/ch-sale-hero.js
 * ------------------------------------------------------------
 * PAIRS WITH:
 *   sections/ch-sale-hero.liquid (v4)
 *   assets/ch-sale-hero.css      (v4)
 *
 * - Cycles .ch-hero__rot-card according to data-rot-speed
 * - Crossfades the per-brand background layer (__rot-vid) in sync
 * - Dots clickable / keyboard-operable to jump
 * - Re-binds on Shopify section load/unload (theme editor)
 * ============================================================ */
(function () {
  'use strict';

  var rotatorTimers = new WeakMap();

  function setActive(list, idx){
    for (var i = 0; i < list.length; i++){
      list[i].classList.toggle('is-active', i === idx);
    }
  }

  function gotoCard(visual, nextIdx){
    var rotator = visual.querySelector('[data-brand-rotator]');
    if (!rotator) return;
    var stage = rotator.querySelector('[data-rotator-stage]');
    if (!stage) return;
    var cards = stage.querySelectorAll('.ch-hero__rot-card');
    if (!cards.length) return;
    nextIdx = ((nextIdx % cards.length) + cards.length) % cards.length;

    var current = stage.querySelector('.ch-hero__rot-card.is-active');
    if (current && current !== cards[nextIdx]){
      current.classList.remove('is-active');
      current.classList.add('is-leaving');
      // strip the leave class after the longest animation duration
      setTimeout(function(){ current.classList.remove('is-leaving'); }, 700);
    }
    var next = cards[nextIdx];
    if (next){
      next.classList.remove('is-leaving');
      // force reflow to restart the CSS animation
      void next.offsetWidth;
      next.classList.add('is-active');
    }

    var dotsEl = rotator.querySelector('[data-rotator-dots]');
    if (dotsEl) setActive(dotsEl.querySelectorAll('.dot'), nextIdx);

    // keep the background photo layer in step with the card
    var vids = visual.querySelectorAll('[data-rotator-videos] .ch-hero__rot-vid');
    if (vids.length) setActive(vids, nextIdx);

    visual.dataset.activeIndex = String(nextIdx);
  }

  function stopTimer(visual){
    var t = rotatorTimers.get(visual);
    if (t){ clearInterval(t); rotatorTimers.delete(visual); }
  }

  function resetTimer(visual){
    stopTimer(visual);
    var total = visual.querySelectorAll('.ch-hero__rot-card').length;
    if (total < 2) return;

    var sec = parseFloat(visual.getAttribute('data-rot-speed'));
    if (!sec || sec < 1) sec = 5;
    var ms = Math.max(1200, sec * 1000);

    var t = setInterval(function(){
      var current = parseInt(visual.dataset.activeIndex || '0', 10);
      gotoCard(visual, current + 1);
    }, ms);
    rotatorTimers.set(visual, t);
  }

  function initRotator(visual){
    if (!visual || visual.dataset.chHeroInit === '1') return;
    visual.dataset.chHeroInit = '1';

    if (visual.getAttribute('data-hero-mode') !== 'rotator') return;

    var rotator = visual.querySelector('[data-brand-rotator]');
    if (!rotator) return;

    // Click / keyboard on dots to jump
    var dotsEl = rotator.querySelector('[data-rotator-dots]');
    if (dotsEl){
      dotsEl.addEventListener('click', function (e){
        var dot = e.target.closest('.dot');
        if (!dot) return;
        var idx = parseInt(dot.getAttribute('data-index'), 10);
        if (isNaN(idx)) return;
        gotoCard(visual, idx);
        resetTimer(visual);
      });
      dotsEl.addEventListener('keydown', function (e){
        if (e.key !== 'Enter' && e.key !== ' ') return;
        var dot = e.target.closest('.dot');
        if (!dot) return;
        e.preventDefault();
        var idx = parseInt(dot.getAttribute('data-index'), 10);
        if (isNaN(idx)) return;
        gotoCard(visual, idx);
        resetTimer(visual);
      });
    }

    // Pause autoplay while hovering (helpful when there are CTAs nearby)
    visual.addEventListener('mouseenter', function(){ stopTimer(visual); });
    visual.addEventListener('mouseleave', function(){ resetTimer(visual); });

    // Respect prefers-reduced-motion
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!reduce){
      resetTimer(visual);
    }
  }

  function initAll(){
    var visuals = document.querySelectorAll('.ch-hero__visual[data-hero-visual]');
    for (var i = 0; i < visuals.length; i++) initRotator(visuals[i]);
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Shopify theme editor -- re-init when this section is loaded/updated
  document.addEventListener('shopify:section:load', function (e){
    var visual = e.target.querySelector ? e.target.querySelector('.ch-hero__visual[data-hero-visual]') : null;
    if (visual){
      delete visual.dataset.chHeroInit;
      initRotator(visual);
    }
  });
  document.addEventListener('shopify:section:unload', function (e){
    var visual = e.target.querySelector ? e.target.querySelector('.ch-hero__visual[data-hero-visual]') : null;
    if (visual) stopTimer(visual);
  });

  // Theme editor -- block selected: jump rotator to that block
  document.addEventListener('shopify:block:select', function (e){
    var block = e.target;
    if (!block.classList || !block.classList.contains('ch-hero__rot-card')) return;
    var visual = block.closest('.ch-hero__visual');
    if (!visual) return;
    var idx = parseInt(block.getAttribute('data-index'), 10);
    if (!isNaN(idx)){
      gotoCard(visual, idx);
      resetTimer(visual);
    }
  });
})();